import React from "react";
import HeroCarousel from "../components/HeroCarousel";
import AboutSection from "../components/AboutSection";
import ServicesSection from "../components/ServicesSection";
import StatsSection from "../components/StatsSection";
import SectorsSection from "../components/SectorsSection";
import ContactSection from "../components/ContactSection";

export default function HomePage() {
  return (
    <main>
      <HeroCarousel />
      <AboutSection />
      <ServicesSection />
      <StatsSection />
      <SectorsSection />
      <ContactSection />
    </main>
  );
}
